export enum AssistanceTerritorialScopeOption {
    ASSISTANCE_TERRITORIAL_SCOPE_NO = 'ASSISTANCE_TERRITORIAL_SCOPE_NO',
    ASSISTANCE_TERRITORIAL_SCOPE_PL = 'ASSISTANCE_TERRITORIAL_SCOPE_PL',
    ASSISTANCE_TERRITORIAL_SCOPE_EU_PL = 'ASSISTANCE_TERRITORIAL_SCOPE_EU_PL',
}
